export class TabularGridManagerRowActions {
    manager;
    showOnRowHover;
    showOnRowActions;
    showOnRowContext;
    constructor(manager) {
        this.manager = manager;
        this.manager.grid
            .querySelectorAll("ch-tabular-grid-row-actions")
            ?.forEach(rowActions => {
            if (rowActions.showOnRowHover) {
                this.showOnRowHover = rowActions;
            }
            if (rowActions.showOnRowActions) {
                this.showOnRowActions = rowActions;
            }
            if (rowActions.showOnRowContext) {
                this.showOnRowContext = rowActions;
            }
        });
    }
}
